export enum FeeType {
  income = 'Income',
  periodic = 'Periodic',
  oneTime = 'OneTime',
  unpredictable = 'Unpredictable'
}
